import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { useStore } from '@nanostores/react';
import { useCookies } from 'react-cookie';
import { useFlag } from '@unleash/proxy-client-react';
import { $shouldDisplayFeedbackAtom } from '~/atoms';
import FeedbackPopup from './feedbackPopup';
import { isEventViewable } from '~/utils/helpers';
const mockPlayer = document.createElement('div');
mockPlayer.id = 'mock-jwplayer-0';
const FeedbackPopopPortal = ({ status, closePopup, eventId, }) => {
    const feedbackOn = useFlag('feedback-form');
    const shouldDisplay = useStore($shouldDisplayFeedbackAtom) ?? false;
    const cookieName = `OneroomFeedback-${eventId}`;
    const [cookies] = useCookies([cookieName]);
    const player = process.env.NODE_ENV === 'test'
        ? mockPlayer
        : document.querySelector(isEventViewable(status) ? '#mediaPlayer' : '#post-event-screen');
    const shouldRenderFeedback = feedbackOn &&
        player &&
        shouldDisplay &&
        !cookies[cookieName];
    // Don't display feedback popup if user already filled in / closed
    if (!shouldRenderFeedback) {
        return null;
    }
    return createPortal(_jsx(FeedbackPopup, { closePopup: closePopup }), player);
};
export default FeedbackPopopPortal;
